<template>
  <v-container fill-height fluid class="background" style="max-height: 100vh;">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="#000000">
            <v-toolbar-title class="white--text"
              >INEGI Energy Metering Platform</v-toolbar-title
            >
            <v-spacer />
            <v-avatar color="tranparent" size="70">
              <img src="../assets/img/inegi_icon.png" />
            </v-avatar>
          </v-toolbar>
          <p align="center" class="title font-weight-bold">
            Project User Registration
          </p>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="firstname"
                label="First Name"
              ></v-text-field>
              <v-text-field v-model="lastname" label="Last Name"></v-text-field>
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :error-messages="passwordErrors"
                label="Password"
                required
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              />
              <v-checkbox
                v-model="checkbox"
                :error-messages="checkboxErrors"
                label="I agree with terms and conditions"
                required
                @change="$v.checkbox.$touch()"
                @blur="$v.checkbox.$touch()"
              ></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block class="mr-4" color="inegi_red" @click="register">
              register
            </v-btn>
            <v-btn block color="inegi_grey" @click="clear">
              clear
            </v-btn>
          </v-card-actions>
          <!-- <v-divider class="mt-5" /> -->
          <!-- <v-card-actions>
            <v-btn color="success" @click="register">Register </v-btn>
          </v-card-actions> -->
          <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="snackColor"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn dark flat @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    firstname: {},
    lastname: {},
    email: { required, email },
    password: { required, minLength: minLength(6) },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },

  data: () => ({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    checkbox: false,
    showPassword: false,
    errorMessages: "",
    snackbar: false,
    snackColor: "",
    color: "general",
    checkboxError: false,
    emailError: false,
    passwordError: false,
  }),

  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.checked && errors.push("You must agree to continue!");
      this.checkboxError = errors.length == 0 ? false : true;
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      this.emailError = errors.length == 0 ? false : true;
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("Password must be at least 6 characters");
      !this.$v.password.required && errors.push("Password is required.");
      this.passwordError = errors.length == 0 ? false : true;
      return errors;
    },
  },

  methods: {
    register() {
      this.$v.$touch();
      if (this.email == "" || this.password == "") {
        this.requiredInline();
      } else if (this.checkbox == false) {
        this.termsAndConditionsInline();
      } else if (
        !this.checkboxError &&
        !this.passwordError &&
        !this.emailError
      ) {
        let firstname = this.firstname;
        let lastname = this.lastname;
        let email = this.email;
        let password = this.password;
        this.$store
          .dispatch("signup", {
            firstname,
            lastname,
            email,
            password,
          })
          .then((response) => {
            // this.signUpOkInline();
            // this.clear();
            setTimeout(() => {
              //   this.$router.push("/register_success");
              this.$router.push({
                name: "register_success",
                params: { data: email },
              });
            }, 1000);
          })
          .catch((err) => {
            if (err == 409) {
              this.userExistsErrorInline();
            } else {
              this.apiErrorInline();
            }
          });
      }
    },

    clear() {
      this.$v.$reset();
      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.password = "";
      this.address = "";
      this.supplynumber = "";
      this.kwhprice = "";
      this.checkbox = false;
    },
    requiredInline() {
      this.snackbar = true;
      this.snackColor = "error";
      this.errorMessages = "Please fill all required fields";
    },
    termsAndConditionsInline() {
      this.snackbar = true;
      this.snackColor = "error";
      this.errorMessages = "Terms and conditions checkbox must be checked";
    },
    apiErrorInline() {
      this.snackbar = true;
      this.snackColor = "error";
      this.errorMessages = "There was an error executing the request";
    },
    userExistsErrorInline() {
      this.snackbar = true;
      this.snackColor = "error";
      this.errorMessages = "User already exists";
    },
    signUpOkInline() {
      this.snackbar = true;
      this.snackColor = "success";
      this.errorMessages =
        "User registration is successful! Awaiting the administrator's approval. You will receive an e-mail soon.";
    },
  },
  metaInfo() {
    return {
      title: "INEGI Energy Metering Platform",
    };
  },
};
</script>

<style scoped>
.background {
  background-color: darkgray;
  width: 100%;
  height: 100%;
}
</style>
